export default {

    computed: {
        xAxisDateField() {
            return this.params.report_type === 'funded' ? 'funded_date' : 'created_date';
        },
    },

    methods: {
        setBarChart() {
            let dateRange = this.getBarChartDateRange();
            this.formattedBarChart = this.parseData({
                data: this.bar_chart,
                dateField: this.xAxisDateField,
                startDate: dateRange.from,
                stopDate: dateRange.to
            });
        },

        getBarChartDateRange() {
            let fromDate;
            let toDate;
            
            if (this.params) {
                if (this.params[this.xAxisDateField] && this.params[this.xAxisDateField].length) {
                    fromDate = this.params[this.xAxisDateField][0];
                    toDate = this.params[this.xAxisDateField][1];
                } else {
                    fromDate = this[`${this.params.report_type}_stats`][`${this.xAxisDateField}_min`];
                    toDate = this[`${this.params.report_type}_stats`][`${this.xAxisDateField}_max`];
                }
            }

            return {
                from: fromDate,
                to: toDate
            };
        },

        getDefaultDateRange() {
            return {
                [this.xAxisDateField]: [
                    moment().subtract(12, 'months').format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD')
                ]
            }
        },

        setDefaultDateRange() {
            this.$store.commit('loanReport/commitFilter', this.getDefaultDateRange());
        },
    }
}